<div class="content">
  <div class="title-card">
    <h1 class="page-title">
      Create Application
    </h1>
    <div style="clear:both"></div>
  </div>
  <div *ngIf="products.length > 0" class="app-container row">
    <div class="col-3">
      <mat-card class="no-padding">
        <mat-accordion multi>
          <mat-expansion-panel expanded>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Products
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-radio-group #productList (change)="onProductChanged($event)"
                             class="productList">
              <mat-radio-button *ngFor="let product of products" id="{{product.productUID}}"
                                value="{{product.code}}">{{product.code}} - {{product.name}}
              </mat-radio-button>
            </mat-radio-group>
          </mat-expansion-panel>
        </mat-accordion>
      </mat-card>
    </div>

    <div class="col">
      <mat-card>
        <div *ngIf="this.productErrors.length != 0" class="boxedValidation" id="productInterestValidation">
          <b>Please select the following fields:</b>
          <div class="labelMargin"></div>
          <li *ngFor="let error of productErrors;" class="errorText">
            {{error}}
          </li>
        </div>
        <app-validation></app-validation>
        <div class="row" *ngIf="hideJointApplicantCheckField === false">
          <div class="col">
            <div class="joint-select d-inline align-middle">Is there a Co-Applicant?&emsp;</div>
            <mat-radio-group (change)="multipleApplicantChange($event)" [(ngModel)]="jointApplicant"
                             class="applicant-radio-group"
                             id="jointApplicant"
            >
              <mat-radio-button [checked]="(jointApplicant)" [value]="true" id="jointApplicantYes">Yes
              </mat-radio-button>
              <mat-radio-button [checked]="(!jointApplicant)" [value]="false" id="jointApplicantNo">No
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div>
          <div fxLayout="row" fxLayoutGap="20px">
            <app-internal-details [internalDetailsFormGroup]="getInternalDetailsDataForm" [isMandatory]="false"></app-internal-details>
          </div>
        </div>
        <mat-divider></mat-divider>
        <mat-tab-group *ngIf="!hideSecondaryApplicant" class="joint-tabs" id="joint-tab-group">
          <form [formGroup]="appForm">
            <div *ngFor="let applicantGroup of applicantGroups; let indexOfElements = index;">
              <mat-tab label="{{getApplicantType(applicantGroup,indexOfElements)}}">
                <app-tell-us-about-yourself [formGroup]="getTellUsAboutYourselfFormGroup(applicantGroup)"
                                            [selectedProduct]="selectedProduct"
                                            [getPrimaryTellUsAboutYourselfData]="sendPrimaryTellUsAboutYourselfData"></app-tell-us-about-yourself>
                <mat-divider></mat-divider>
                <app-employment-details *ngIf="getApplicantType(applicantGroup, indexOfElements) != 'Minor Applicant'"
                                        [formGroup]="getEmploymentDetailsFormGroup(applicantGroup)"></app-employment-details>
              </mat-tab>
            </div>
          </form>
        </mat-tab-group>

        <div *ngIf="hideSecondaryApplicant">
          <div *ngFor="let applicantGroup of applicantGroups; let first = first;">
            <form *ngIf="first" [formGroup]="appForm">
              <app-tell-us-about-yourself
                [formGroup]="getTellUsAboutYourselfFormGroup(applicantGroup)"
                [selectedProduct]="selectedProduct"></app-tell-us-about-yourself>
              <mat-divider></mat-divider>
              <app-employment-details
                [formGroup]="getEmploymentDetailsFormGroup(applicantGroup)"></app-employment-details>
              <mat-divider></mat-divider>
            </form>
          </div>
        </div>
        <app-bsa-profile *ngIf="!shouldHideBsaQuestions" [hasCoApplicant]="jointApplicant" [displayCheckOrder]="shouldDisplayOrderCheckQues" [displayDebitOrder]="shouldDisplayOrderDebitQues"></app-bsa-profile>
        <button mat-button class="tcb-button" [disabled]="disableCreateButton" (click)="onCreateApplication($event)">
          Create Application
        </button>
      </mat-card>
    </div>
  </div>
</div>
